import { Assets } from "utils/imports.utils";
import { TransformType } from "utils/interface.utils";
import { TransformCursorState } from "interfaces/editor_workspace.interface";

const DEFAULT_CURSOR = 'default';
// Every cursor SVG is 24x24 and drawn around its centre, so the hotspot is the middle.
const HOTSPOT = '12 12';

const svgCursor = (asset: string, fallback: string): string => `url("${asset}") ${HOTSPOT}, ${fallback}`;

const getScaleCursor = (corner: string | null): string => {
    const isNeswCorner = corner === 'topRight' || corner === 'bottomLeft';
    return isNeswCorner
        ? svgCursor(Assets.cursor_resize_nesw, 'nesw-resize')
        : svgCursor(Assets.cursor_resize_nwse, 'nwse-resize');
};

// The cursor for the canvas: the active transform tool decides it, a hovered corner refines it
// (scale picks that corner's diagonal) and dragging swaps the keyword fallback to `grabbing`.
export const getTransformCursor = ({ tool, corner, dragging }: TransformCursorState): string => {
    switch (tool) {
        case TransformType.POSITION:
            return svgCursor(Assets.cursor_move, dragging ? 'grabbing' : 'move');
        case TransformType.ROTATION:
            return svgCursor(Assets.cursor_rotate, dragging ? 'grabbing' : 'grab');
        case TransformType.SCALE:
            return getScaleCursor(corner);
        default:
            return DEFAULT_CURSOR;
    }
};

export const applyTransformCursor = (canvas: HTMLCanvasElement | null, state: TransformCursorState): void => {
    if (!canvas) return;
    canvas.style.cursor = getTransformCursor(state);
};
